<template>
  <div>
    <menu-pae :inFocus="false" :isVisible="false">
      <template>
        <div id="menuMesagem">
          <div class="acoes">
            <button class="btn btn-danger" @click.prevent="voltar"> Voltar </button>
            <button v-if="criarMensagemIsVisible()" class="btn btn-primary" @click.prevent="() => $router.push({ name: 'Criar Mensagem' })"> Nova Mensagem </button>
          </div>
        </div>
      </template>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Caixa de Mensagem</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="container mt-2">
      <div class="row">
        <div class="col-4">
          <div class="list-group" id="list-tab" role="tablist">
            <a
              v-for="(message, index) in data"
              :key="`${message.securityKey}-link`"
              :class="`list-group-item list-group-item-action flex-column align-items-start`"
              :id="`${message._id}-link`"
              data-toggle="list"
              :href="`#${index}-item`"
              role="tab"
              :aria-controls="message.titulo"
              @click.prevent="openText(index)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ message.titulo }}</h5>
                <small>{{ formatData(message.dataCriacao) }}</small>
              </div>
            </a>
          </div>
        </div>
        <div class="col-8 border-top p-2">
          <div class="tab-content" id="nav-tabContent">
            <div
              v-for="(message, index) in data"
              :key="`${message.securityKey}-item`"
              :class="`tab-pane fade ${choosen === index ? 'show active' : ''}`"
              :id="`${index}-item`"
              role="tabpanel"
              :aria-labelledby="`${index}-item`">
              <div class="d-flex justify-content-end">
                <button class="btn btn-primary" @click.prevent="() => $router.push({ path: `/caixa/${message.identificador}/edit` })"> Editar Mensagem </button>
              </div>
              <p>{{ message.texto }}</p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <pagination-comp :pagination="pagination" :eventBusDataPaginationName="eventBusDataPaginationName"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import VirtusMensagemService from '@/services/VirtusMensagemService'
import { localDateParse } from '@/uteis/converters/LocalDateConverter'
import { componentIsVisible, rules } from '@/uteis/action/permissao'
import paginationComp from '@/components/pagination/PaginationComp'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'caixa-mensagem',
  components: {
    menuPae,
    paginationComp
  },

  created () {
    this.service = new VirtusMensagemService()
    this.pesquisar()

    eventBus.$on(this.eventBusDataPaginationName, (page) => {
      this.pesquisar(page)
    })
  },

  data () {
    return {
      choosen: '',
      securityKey: '',
      filtro: {
        offset: 1,
        range: 10,
        'destino.tipoIdentificador': 'PAPEL'
      },
      data: [],
      pagination: {
        hasPrev: false,
        hasNext: false,
        totalPage: 0
      },
      eventBusDataPaginationName: 'consultaMensagemPagination'
    }
  },

  methods: {
    voltar () {
      this.$router.back()
    },

    criarMensagemIsVisible () {
      const { CRIAR_ALERTA } = rules
      return componentIsVisible(CRIAR_ALERTA)
    },

    pesquisar (page = 1) {
      this.filtro.offset = page

      this.service.getMensagens(this.filtro).then(res => {
        this.data = res.data
        this.pagination = res.pagination
      }).catch(err => {
        console.log(err)
      })
    },

    openText (index) {
      this.choosen = index
    },

    formatData (date) {
      return localDateParse(date).value
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div{
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;
  &--primary {
    background-color: green;
    color: #fff;
  }
  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
